import React from 'react';

import { formatKpiString, locale } from '@trqk/utils';

import { BulkPaymentsTableRow } from '.';

interface BulkPaymentsTableProps {
    kpis: ProKpis;
}

export const BulkPaymentsTable = ({
    kpis,
}: BulkPaymentsTableProps): JSX.Element => {
    const rows: BulkPaymentsTableRowConfig[] = [
        {
            label: locale.enUS.STATEMENTS.KPIS.ADJUSTMENTS,
            value: formatKpiString({
                kpis,
                kpiType: 'earnings_adjustments',
                asDollars: true,
            }),
        },
        {
            label: locale.enUS.STATEMENTS.KPIS.PROXIES,
            value: formatKpiString({
                kpis,
                kpiType: 'earnings_proxies',
                asDollars: true,
            }),
        },
        {
            label: locale.enUS.STATEMENTS.KPIS.SAMPLE_SURVEYS,
            value: formatKpiString({
                kpis,
                kpiType: 'earnings_surveys',
                asDollars: true,
            }),
        },
        {
            label: locale.enUS.STATEMENTS.KPIS.SETTLEMENTS,
            value: formatKpiString({
                kpis,
                kpiType: 'earnings_settlements',
                asDollars: true,
            }),
        },
        {
            label: locale.enUS.STATEMENTS.KPIS.MISC_BULK,
            value: formatKpiString({
                kpis,

                kpiType: 'earnings_misc_bulk',
                asDollars: true,
            }),
        },
    ];

    return (
        <table className="m-2">
            <tbody>
                {rows.map(
                    (
                        { label, value }: BulkPaymentsTableRowConfig,
                        index: number,
                    ): JSX.Element => (
                        <BulkPaymentsTableRow
                            key={label}
                            label={label}
                            value={value}
                            index={index}
                        />
                    ),
                )}
            </tbody>
        </table>
    );
};
